const initialState = {
  rescheduleId: {},
  rescheduleAppointmentData: null,
  rescheduleFullScreenEnb: null,
};

export default (state = Object.assign({}, initialState), { type, payload }) => {
  switch (type) {
    case "RescheduleId":
      return {
        ...state,
        rescheduleId: payload,
      };

    case "RescheduleData":
      return {
        ...state,
        rescheduleAppointmentData: payload,
      };
    case "fullScreenEnabled":
      return {
        ...state,
        rescheduleFullScreenEnb: payload,
      };
    default:
      return state;
  }
};
